import React from "react";
import { useInViewAnimation } from "../../utils/useInViewAnimation";
import "./teamMember.css";

import member1 from "../../assets/images/1.png";
import member2 from "../../assets/images/2.png";
import member3 from "../../assets/images/3.png";
import member4 from "../../assets/images/4.png";

interface TeamMember {
  name: string;
  role: string;
  imageUrl: string;
  altText: string;
}

const TeamMemberCard: React.FC<TeamMember> = ({ name, role, imageUrl, altText }) => (
  <div
    className="team-member-card animate-item"
    tabIndex={0}                 // keyboard focus
    role="button"                // interactive feel
    aria-label={`View ${name} - ${role}`}
  >
    <div className="member-image-container">
      <img src={imageUrl} alt={altText} className="member-image" />
    </div>
    <h3 className="member-name">{name}</h3>
    <p className="member-role">{role}</p>
  </div>
);

const TeamSection: React.FC = () => {

  const teamMembers: TeamMember[] = [
    { name: "Prathyusha Bupathi", role: "Founder", imageUrl: member4, altText: "Prathyusha Bupathi" },
    { name: "Vijay Bhaskar Athmuri", role: "Director", imageUrl: member1, altText: "Vijay Bhaskar Athmuri" },
    // { name: "Bessie Cooper", role: "Software Development", imageUrl: member3, altText: "Bessie Cooper" },
    { name: "Vijaya Kumar Bupathi", role: "Advisor", imageUrl: member2, altText: "Vijaya Kumar Bupathi" },
  ];

  const sectionRef = useInViewAnimation("in-view", {
    threshold: 0.35,
    rootMargin: "0px 0px -120px 0px",
    once: true,
  });

  return (
    <section
      className="team-section-container"
      ref={sectionRef as React.RefObject<HTMLElement>}
    >
      <div className="team-header">
        <span className="team-tag">Explore Our Team</span>
        {/* <h2 className="team-title">We've Exclusive Team Member</h2> */}
      </div>

      <div className="team-members-grid">
        {teamMembers.map((member) => (
          <TeamMemberCard key={member.name} {...member} />
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
